import { COLOR_MAP } from "../cardData";

export default function HandTiles({groups}){
  return<>{groups.map((g,i)=><span key={i}><span style={{color:COLOR_MAP[g.c]||"#5A8ED8"}}>{g.t}</span>{i<groups.length-1?" ":""}</span>)}</>;
}
